import { EvaluationType, QuantityValueType } from '@/api/generator';
import {} from '@/components/pages/BasePage/defaults';
import { computed } from 'vue';
import { t } from 'i18next';

export const defaultDecimals = {
  [QuantityValueType.FloatingPoint]: 3,
  [QuantityValueType.IntegerNumber]: 0,
};

export const decimalsOptions = Array(15)
  .fill(1)
  .map((offset, index) => index + offset);

export const valueTypeOptions = computed(() => [
  {
    title: t('FloatingPoint'),
    value: QuantityValueType.FloatingPoint,
  },
  {
    title: t('IntegerNumber'),
    value: QuantityValueType.IntegerNumber,
  },
]);

export const evaluationTypeOptions = computed(() => [
  {
    title: t('EvaluationTypeEnum.AbsoluteValue'),
    value: EvaluationType.AbsoluteValue,
  },
  {
    title: t('EvaluationTypeEnum.AbsoluteDifference'),
    value: EvaluationType.AbsoluteDifference,
  },
  {
    title: t('EvaluationTypeEnum.Ratio'),
    value: EvaluationType.Ratio,
  },
  {
    title: t('EvaluationTypeEnum.RelativeDifference'),
    value: EvaluationType.RelativeDifference,
  },
]);
